import { Cms } from '@bytel/product-wall';
import {
    Alignable,
    Card,
    CardContent,
    Column,
    Columns,
    Image,
    Price,
    PriceLevel,
    Spacer,
    SpacerSize,
    Sticker,
    Text,
    Title,
    TitleLevels,
    VariantState,
    View,
} from '@bytel/trilogy-react';

import { StoredHomepackProduct } from '@app-types/home-pack';

import { NuggetsList } from '@components/roc-card';

interface SelectedPackProductCardProps {
    selectedProduct: StoredHomepackProduct;
}

export function SelectedPackProductCard({ selectedProduct }: Readonly<SelectedPackProductCardProps>) {
    return (
        <Columns multiline align={Alignable.ALIGNED_CENTER}>
            <Column>
                <Card>
                    <CardContent className='has-text-centered'>
                        <Title level={TitleLevels.FOUR}>
                            <Cms content={selectedProduct.name} />
                        </Title>
                        {selectedProduct.productSize[0]?.sticker && (
                            <>
                                <Sticker
                                    className='is-hidden-mobile'
                                    small
                                    variant={VariantState.ACCENT}
                                    label={selectedProduct.productSize[0].sticker}
                                />
                                <Sticker
                                    className='is-hidden-tablet'
                                    small
                                    variant={VariantState.ACCENT}
                                    label={
                                        selectedProduct.productSize[0].stickerMobile ??
                                        selectedProduct.productSize[0].sticker
                                    }
                                />
                            </>
                        )}
                        <Spacer size={SpacerSize.FOUR} />
                        <Text className='is-flex is-centered is-aligned-bottom gap-medium'>
                            {selectedProduct.productSize[0]?.price && (
                                <Price
                                    level={PriceLevel.FIVE}
                                    oldAmount={selectedProduct.productSize[0].priceStriked}
                                    amount={selectedProduct.productSize[0].price}
                                />
                            )}
                        </Text>
                        <Spacer size={SpacerSize.FIVE} />
                        <View flexable className='is-centered'>
                            <Image alt='' src={selectedProduct.image} height={150} />
                        </View>
                        <Spacer size={SpacerSize.FIVE} />
                        {selectedProduct.productDetails?.length > 0 && (
                            <NuggetsList
                                nuggets={selectedProduct.productDetails.map((product) => ({
                                    icon: product.iconeTrilogy,
                                    label: product.pepite,
                                }))}
                            />
                        )}
                    </CardContent>
                </Card>
            </Column>
        </Columns>
    );
}
